import React, { Fragment, useEffect, useRef , useState} from 'react';
import { useSelector, useDispatch } from "react-redux";
import { getMediaPath } from "app/functions";
import ReactHtmlParser from 'react-html-parser';
import AnalyticsManager from '../../app/analytics';

//components
import JoinForm from './sections/join-form/join-form';
import BreadCrumbs from '../../components/common/bread_crumbs';

//actions
import { useGetSuppliersApplicationPageQuery } from "redux/api/relations.api";


//assets
import './supplier-join.scss';
import * as routes from "../../constants/routes";
import ImageHeader from "../../components/image-header";

const SupplierJoin = (props) => {
    const joinFrom = useRef();

    const deviceState = useSelector(store => store.state.deviceState);

    const { data: suppliersJoinPageData } = useGetSuppliersApplicationPageQuery();
    const [suppliersJoinPage, setSuppliersJoinPage] = useState(suppliersJoinPageData);


    useEffect(() => {
        if (suppliersJoinPageData) {
            setSuppliersJoinPage(suppliersJoinPageData);
        }
    }, [suppliersJoinPageData]);

    useEffect(() => {
        if (props.leadStatus) {
            AnalyticsManager.logLeadVendor();
        }
    }, [props.leadStatus]);

    const scrollToForm = () => {
        let header_height = document.getElementsByTagName('header')[0]?.clientHeight;
        let scroll_top = joinFrom.current.getBoundingClientRect().top - header_height;
        window.scrollTo(0, scroll_top);
    };

    const isMobile = deviceState === 'mobile';
    let business_select_data = false;
    let banner = null;
    let iconsArr = [];

    const header = suppliersJoinPage?.details?.header || {};
    const body = suppliersJoinPage?.details?.body || {};
    const icons  = suppliersJoinPage?.icons;
    if(suppliersJoinPage) {
        banner = isMobile ? getMediaPath(header.mobileImagePath) : getMediaPath(header.imagePath);
        iconsArr = icons?.map((item, index) => {
            return (
                <div className="item" key={ index }>
                    <img className='icon' src={ getMediaPath(item.imagePath) } alt="" />
                    <div className="number">{ item.title }</div>
                    <div className="label">{ item.text }</div>
                </div>
            )
        });
        business_select_data = body.workPlaces;
    }

    return(
        <main className='supplier-join'>
            <ImageHeader
                image={banner}
                title={suppliersJoinPage?.details?.header?.title}
                subtitle={suppliersJoinPage?.details?.header?.content}
            >
                {header.btnText && <div className="green-button" onClick={ scrollToForm}>{ header.btnText }</div>}
            </ImageHeader>

            <BreadCrumbs root={{text:'דף הבית', route: routes.home}}/>

            <section className="numbers">
                { iconsArr }
            </section>
            { body.link && body.header && body.content  &&
            <section className="video">
                <div className='youtube-wrapper'>
                    <iframe className="iframe"
                            src={body.link }
                            title={ body.header }
                            referrerPolicy="strict-origin-when-cross-origin"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen/>
                </div>
                <div className="text">
                    <h2 className="title">{ body.header }</h2>
                    <div className="paragraph">{ ReactHtmlParser(body.content)}</div>
                </div>
            </section>
            }

            <div ref={ joinFrom } className='form-container'>
                { business_select_data && body.formTitle  &&
                    <JoinForm data={ business_select_data } title={ body.formTitle } />
                }
            </div>

        </main>
    );
};

export default SupplierJoin;
